const SingleTemplate = (props) => {
  // const [id, setId] = useState(props.id);
  const playMovie = (e) => {
    e.target.play();
    e.target.muted = true;
  };

  const stopMovie = (e) => {
    e.target.pause();
    e.target.load();
  };

  const makeFav = (e, temp_id, fav) => {
    e.preventDefault();
    props.makeIsfav(temp_id, fav);
  };

  return (
    <div className="col-xl-4 col-lg-4 col-md-4" key={props.id}>
      <div
        className={`vd_cl ${
          props.selectedTemp === props.main_temp_id ? "selected" : ""
        }`}
      >
        <div
          className="series_vd position-relative cursor"
          onClick={(e) => {
            props.templateId(props.main_temp_id);
          }}
        >
          <video
            src={props.preview_url}
            poster={props.thumbnail_url}
            //   preload="none"
            loop
            width="100%"
            onMouseOver={playMovie}
            onMouseOut={stopMovie}
            // className="no-coursor"
            // className="cursor"
          />
        </div>
        <div className="bdy_vd position-relative">
          <div className="like_btn">
            <a
              href="#0"
              className={props.is_fav !== 0 && props.is_fav > 0 ? "active" : ""}
              onClick={(e) => {
                makeFav(e, props.id, props.is_fav);
              }}
              data-toggle="tooltip"
              data-placement="top"
              title={
                props.is_fav !== 0 && props.is_fav > 0
                  ? "Remove From Favourite"
                  : "Add To Favourite"
              }
              data-bs-original-title={
                props.is_fav !== 0 && props.is_fav > 0
                  ? "Remove From Favourite"
                  : "Add To Favourite"
              }
            >
              <i className="fa fa-heart-o"></i>
            </a>
          </div>
          <h4 className="pb-4 pt-4 text-center text-capitalize">
            {props.name}
          </h4>
          <button
            className={`btn btn2 w-100 ${
              props.selectedTemp === props.main_temp_id ? "selected_temp" : ""
            }`}
            onClick={(e) => {
              props.templateId(props.main_temp_id);
            }}
          >
            {props.selectedTemp === props.main_temp_id ? "Selected" : "Select"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleTemplate;
